import {
    SET_TASK_LIST,
    SET_TASK_LIST_FILTER_DATA,
    SET_TASK_LIST_META,
    TASK_INIT_STATE
} from "./types";

export const taskReducer = (state = TASK_INIT_STATE, action) => {
    switch (action.type) {
        case SET_TASK_LIST:
            return {...state, taskList: action.payload};
        case SET_TASK_LIST_META:
            return {...state, taskListMeta: action.payload};
        case SET_TASK_LIST_FILTER_DATA:
            return {...state, taskListFilterData: action.payload};
        default:
            return state
    }
}